import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterOutlet } from '@angular/router';
import { AuthCustomService } from '../../security/auth-custom.service';
import { MediaMatcher } from '@angular/cdk/layout';

import { Router } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthService } from '@auth0/auth0-angular';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { NotificationComponent } from '../../my-account/notification/notification.component';
import { SideBarToggleService } from '../../shared/side-bar-toggle.service';
import { appVersion, buildDate } from '../../../environments/version';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    SidebarComponent,
    NotificationComponent,
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: 'core.component.html',
  styleUrls: ['core.component.scss']
})
export class CoreComponent implements OnInit, OnDestroy {
  public authCustomService = inject(AuthCustomService);
  public auth = inject(AuthService);
  private deviceService = inject(DeviceDetectorService);
  opened = true;
  mobileQuery: MediaQueryList;
  isMobile: boolean;
  appVersion = appVersion;
  deployDate = this.getDateVersion();
  private _mobileQueryListener: () => void;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private router: Router,
    private sideBarToggleService: SideBarToggleService,

  ) {
    this.isMobile = this.deviceService.isMobile();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);

    // Atualiza o estado da barra lateral com base no serviço
    this.sideBarToggleService.changeEmitted$.subscribe((open) => {
      this.opened = open;
    });
    if (this.isMobile) {
      this.opened = false; // Fecha a barra lateral em dispositivos móveis
    }
  }

  async ngOnInit(): Promise<void> {
    const isAuthenticated = this.authCustomService.hasValidToken();
    const themeStored = localStorage.getItem('theme');
    if (themeStored === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.setAttribute('theme', themeStored);
    }
  }

  getDateVersion(): string {
    const datex = new Date(buildDate);
    const formattedDate = datex.toLocaleDateString();
    const formattedTime = datex.toLocaleTimeString();
    return `${formattedDate} ${formattedTime}`;
  }

  ngOnDestroy(): void {
    // Remove o listener para evitar vazamentos de memória
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }

  // Fecha a barra lateral
  closeSideBar(): void {
    this.opened = false;
  }

  // Sincroniza o estado quando o sidebar é aberto/fechado por qualquer meio (ESC, clique fora, etc)
  onSidenavOpenedChange(opened: boolean): void {
    this.opened = opened;
    // Opcionalmente, também pode notificar o serviço de toggle
    this.sideBarToggleService.emitChange(opened);
  }
}
